export default "__VITE_ASSET__5de52d26__"